export default __webpack_public_path__ + "static/media/Arbo-real.48214536.png";